import useSWR from 'swr';

import { fetchQuickAddOptions, type QuickAddOptions } from '../data/quickAddRepository.js';

export const QUICK_ADD_OPTIONS_KEY = 'transactions/quick-add-options';

export type QuickAddOptionsState =
  | { status: 'loading' }
  | { status: 'error'; message: string; retry: () => void }
  | { status: 'ready'; options: QuickAddOptions; refresh: () => Promise<unknown> };

/**
 * The accounts, categories and income sources Quick Add offers.
 *
 * `keepPreviousData` matters here: the screen is opened from the raised ⊕ button many times a
 * day, and a revalidation must never blank the category chips out from under a thumb that is
 * already moving towards one.
 */
export function useQuickAddOptions(): QuickAddOptionsState {
  const { data, error, isLoading, mutate } = useSWR<QuickAddOptions, Error>(
    QUICK_ADD_OPTIONS_KEY,
    fetchQuickAddOptions,
    { revalidateOnFocus: false, shouldRetryOnError: false, keepPreviousData: true },
  );

  if (error) {
    return {
      status: 'error',
      message: error.message || 'Không tải được danh mục và tài khoản.',
      retry: () => {
        void mutate();
      },
    };
  }

  if (isLoading || !data) return { status: 'loading' };

  return { status: 'ready', options: data, refresh: () => mutate() };
}
